const Footer = () => {
  return(
    <footer>
      <p>Created by Brennan Curtis, Harpreet Singh, Brodie Day, and Yousef Salih using the <a className="footerLink" href="https://opentdb.com/">Open Trivia Database API</a> at <a className="footerLink" href="https://junocollege.com/">Juno College</a></p>
    </footer>
  )
}

export default Footer;